export interface Law {
  amendments: string[];
  id: string;
  syllabus: string;
  title: string;
}

export const laws: Law[] = [
  {
    id: "law1",
    title: "Lei Complementar nº 001, de 13 de setembro de 1990",
    syllabus:
      "Dispõe sobre a organização, competência, a estrutura da Procuradoria-Geral do Município, sobre o Regime Jurídico de seus servidores e dá outras providências.",
    amendments: [
      "Lei Complementar n.5, 25.09.91, DOM 29.10.1991, p.01, alteração, art. 100, anexos III e IV.",
      "Lei n.7844 de 06.12.95, DOM 14.12.1995, legislação correlata.",
      "Lei n.8640, 18.06.02, DOM 25.06.2002, p.01, alteração.",
      "Lei n.8864, 29.06.04, DOM 29.06.2004, p.01, alteração.",
      "Lei n.8941, 09.06.05, DOM 09.06.2005, p.01, legislação correlata.",
      "Lei n.9101, 31.05.06, DOM 31.05.2006, p.02, legislação correlata.",
      "Decreto n.14530, 08.11.19, DOM 19.11.2019, p.01, legislação correlata, art.104.",
      "Lei Complementar n.315, 23.12.11, DOM 23.12.2021, p.01, legislação correlata.",
    ],
  },
  {
    id: "law2",
    title: "Lei Complementar nº 001, de 13 de setembro de 1990",
    syllabus:
      "Dispõe sobre a organização, competência, a estrutura da Procuradoria-Geral do Município, sobre o Regime Jurídico de seus servidores e dá outras providências.",
    amendments: [
      "Lei complementar n.9, 29.06.94, DOM 30.06.1994, alteração.",
      "Lei complementar n.10, 29.10.95, DOM 11.10.1995, p.01, alteração, art.6.",
      "Lei n.7844, 06.12.95, DOM 14.12.1995, p.01, legislação correlata.",
      "Decreto n.10015, 20.12.96, DOM 07.01.1997, p.03, regulamentação art. 24, inc.I.",
      "Lei n.8748, 10.07.03, DOM 22.07.2003, p.04, legislação correlata art. 99, parágrafo único.",
      "Lei Complementar n.016, 24.05.04, DOM 28.05.2004, p.01, alteração:anexo II, arts. 53, 90, 101 e 102; revogação art. 106; legislação correlata art. 4º itens 1.1 e 1.2 e art. 11.",
      "Lei Complementar n.071, 23.11.09, DOM 30.11.2009, p.01, acréscimo art. 22A, Seção III, Capítulo VI, Título I; alteração arts. 3º, 4º, 6º, 10º, 12, 15, 18, 21, 22, 23, 28, 32, 33, 43 e 53; alteração anexo I e II inciso I e II; acréscido capítulo V, Título I, Seções IV, V, VI e VII e arts 13A, 13B, 13C, 13D e alteração arts. 15 e 18.",
      "Lei complementar n.100, 26.12.11, DOM 02.01.2012, p.08, alteração.",
      "Lei Complementar n.122, 30.11.12, DOM 12.12.2012, p.01, alteração art. 4º.",
      "Decreto n.13149, 29.04.13, DOM 30.04.2013, p.06, regulamentação.",
      "Lei Complementar n.151, 04.07.13, DOM 05.07.2013, p.13, alteração art. 33.",
      "Lei Complementar n.171, 27.11.14, DOM 02.12.2014, p.01, revogação art. 102 parágrafo único, alteração art. 4°, capítulo VI, título I.",
      "Lei Complementar n.0176, 19.12.14, DOM 19.12.2014, p.07, legislação correlata.",
      "Lei Complementar n.0185, 19.12.14, DOM 19.12.2014, p.34, alteração arts. 4°, 7°, § único, 12, 13-C, anexo I.",
      "Lei Complementar n.0190, 22.12.14, DOM 22.12.2014, p.01, legislação correlata.",
      "Decreto n.13601, 03.06.15, DOM 12.06.2015, p.01, regulamentação, Título I, Capítulo VI, Seção VIII.",
      "Decreto n.13733, 28.12.15, DOM 29.12.2015, p.13, legislação correlata, art. 31-P, § 3°.",
      "Lei Complementar n.0252, 03.07.18, DOM 12.07.2018, p.21, alteração arts. 12; 13-D; 31-B §§2º, 3º e 4º; 31-B2; 33; 34; 4º itens 2 e 4; acresce seção XII, art. 31-O; arts. 34-A, 34-B.",
      "Lei Complementar n.0253, 03.07.18, DOM 12.07.2018, p.24, acresce §§ 4º e 5º ao art. 31-O.",
      "Decreto n.14530, 08.11.19, DOM 19.11.2019, p.01, legislação correlata.",
      "Lei Complementar n.0274, 20.12.19, DOM 23.12.2019, p.05, acresce art. 22-B; alteração anexo I.",
      "Lei Complementar n.0283, 27.12.19, DOM 30.12.2019, p.01, legislação correlata.",
      "Decreto n.14600, 27.02.20, DOM 27.02.2020, p.05, legislação correlata. (SEGER) Decreto n.14911, 20.01.21, DOM 21.01.2021, p.01, legislação correlata (envio atos normativos).",
      "Lei Complementar n.315, 23.12.11, DOM 23.12.2021, p.01, legislação correlata.",
    ],
  },
  {
    id: "law3",
    title: "Lei Complementar nº 009, de 29 de junho de 1994",
    syllabus:
      "Acresce dispositivos à Lei Complementar nº 006, de 29 de maio de 1992, renumera artigos e adota outras providências.",
    amendments: [
      "Lei Complementar n.016, 24.05.04, DOM 28.05.2004, p.01, legislação correlata.",
    ],
  },
  {
    id: "law4",
    title: "Lei Complementar nº 010, de 29 de setembro de 1995",
    syllabus:
      "Altera a Lei Orgânica da Procuradoria-Geral do Município.",
    amendments: [
      "Lei Complementar n.016, 24.05.04, DOM 28.05.2004, p.01, legislação correlata. art.1.",
    ],
  },
  {
    id: "law5",
    title: "Lei Complementar nº 016, de 24 de maio de 2004",
    syllabus:
      "Cria cargos de Procurador do Município de Fortaleza e altera dispositivos da Lei Orgânica da Procuradoria-Geral do Município de Fortaleza, Lei Complementar nº 006, de 29 de maio de 1992, com suas alterações posteriores, e dá outras providências.",
    amendments: [
      "Decreto n.14530, 08.11.19, DOM 19.11.2019, p.01, legislação correlata.",
    ],
  },
  {
    id: "law6",
    title: "Lei Complementar nº 071, de 23 de novembro de 2009",
    syllabus:
      "Modifica a Lei Orgânica da Procuradoria-Geral do Município e dá outras providências.",
    amendments: [
      "Lei Complementar n.100, 26.12.11, DOM 02.01.2012, p.08, alteração, anexo I.",
      "Lei Complementar n.122, 30.11.2012, DOM 12.12.2012, p.01, alteração, Art. 22 A e anexo I.",
      "Decreto n.13149, 29.04.2013, DOM 30.04.2013, p.06, alteração, anexo I.",
      "Lei Complementar n.151, 04.07.13, DOM 05.07.2013, p.13, alteração art. 33.",
      "Decreto n.13222, 02.10.13, DOM 17.10.2013, p.03, legislação correlata.",
      "Lei Complementar n.157, 19.12.13, DOM 26.12.2013, p.05, legislação correlata.",
      "Decreto n.13365, 13.06.14, DOM 20.06.2014, p.08, legislação correlata.",
      "Lei Complementar n.171, 27.11.14, DOM 02.12.2014, p.01, revogação art. 102.",
      "Lei Complementar n.185, 19.12.14, DOM 19.12.2014, p.34, alteração.",
      "Lei Complementar n.252, 03.07.18, DOM 12.07.2018, p.21, revogação art. 10.",
      "Decreto n.13649, 25.08.15, DOM 31.08.2015, p.01, regulamentação.",
      "Decreto n.14092, 27.09.17, DOM 04.10.2017, p.19, regulamentação (matriz salarial).",
      "Decreto n.14411, 02.05.19, DOM 10.05.2019, p.03, regulamentação (matriz salarial).",
      "Decreto n.14897, 29.12.20, DOM 31.12.2020, p.27, regulamentação (matriz salarial).",
    ],
  },
  {
    id: "law7",
    title: "Lei Complementar nº 100, de 26 de dezembro de 2011",
    syllabus:
      "Modifica o Anexo I da Lei Complementar nº 0071/09, Lei Orgânica da Procuradoria-Geral do Município, e dá outras providências.",
    amendments: [
      "Decreto n.13149, 29.04.2013, DOM 30.04.2013, p.06, legislação correlata.",
    ],
  },
  {
    id: "law8",
    title: "Lei Complementar nº 122, de 30 de novembro de 2012",
    syllabus:
      "Modifica a Lei Orgânica da Procuradoria-Geral do Município e dá outras providências.",
    amendments: [
      "Decreto n.13149, 29.04.2013, DOM 30.04.2013, p.06, legislação correlata.",
    ],
  },
  {
    id: "law9",
    title: "Lei Complementar nº 151, de 04 de julho de 2013",
    syllabus:
      "Altera o art. 33 da Lei Complementar n° 006, de 29 de maio de 1992, a Lei Orgânica da Procuradoria-Geral do Município de Fortaleza.",
    amendments: [
      "Decreto n.13149, 29.04.2013, DOM 30.04.2013, p.06, legislação correlata",
    ],
  },
  {
    id: "law10",
    title: "Lei Complementar nº 171, de 27 de novembro de 2014",
    syllabus:
      "Altera a Lei Orgânica da Procuradoria-Geral do Município de Fortaleza e dá outras providências.",
    amendments: [
      "Decreto n. 13601, 03.06.15, DOM 12.06.2015, p. 01, regulamentação.",
      "Decreto n. 13629, 10.07.15, DOM 29.07.2015, p. 09, legislação correlata.",
      "Decreto n. 13716, 22.12.15, DOM 22.12.2015, p. 01, suplemento, legislação correlata.",
      "Decreto n. 13733, 28.12.15, DOM 29.12.2015, p. 13, legislação correlata.",
      "Lei Complementar n.0283, 27.12.19, DOM 30.12.2019, p.01, legislação correlata.",
      "Lei n.11100, 06.04.21, DOM 07.04.2021, p.01, legislação correlata art 2º, §2º.",
      "Decreto n. 14990, 20.04.21, DOM 20.04.2021, p. 01, legislação correlata.",
      "Decreto n.15643, 01.06.23, DOM 02.06.2023, p.01, legislação correlata.",
    ],
  },
  {
    id: "law11",
    title: "Lei Complementar nº 185, de 19 de dezembro de 2014",
    syllabus:
      "Altera a Lei Orgânica da Procuradoria-Geral do Município (PGM) e dá outras providências.",
    amendments: [
      "Decreto n.13149, 29.04.2013, DOM 30.04.2013, p.06, legislação correlata",
    ],
  },
  {
    id: "law12",
    title: "Lei Complementar nº 252, de 03 de julho de 2018",
    syllabus:
      "Altera a Lei Orgânica da Procuradoria-Geral do Município (PGM) e dá outras providências.",
    amendments: [
      "Decreto n.13149, 29.04.2013, DOM 30.04.2013, p.06, legislação correlata",
    ],
  },
  {
    id: "law13",
    title: "Lei Complementar nº 274, de 20 de dezembro de 2019",
    syllabus:
      "Altera a Lei Orgânica da Procuradoria-Geral do Município (PGM) e dá outras providências.",
    amendments: [
      "Decreto n.13149, 29.04.2013, DOM 30.04.2013, p.06, legislação correlata",
    ],
  },
  {
    id: "law14",
    title: "Lei Complementar nº 315, de 23 de dezembro de 2021",
    syllabus:
      "Consolida e altera a Lei Orgânica da Procuradoria-Geral do Município e dá outras providências.",
    amendments: [
      "Decreto n.15220, 04.01.22, DOM 05.01.2022, p.01, regulamentação, art. 132.",
      "Decreto n.15226, 10.01.22, DOM 10.01.2022, p.02, legislação correlata, art. 43, § 3º.",
      "Decreto n.15444, 01.11.22, DOM 03.11.2022, p.10, legislação correlata, art. 42, § 1º.",
      "Decreto n.15524, 09.01.23, DOM 09.01.2023, p.05, legislação correlata, art. 135.",
      "Decreto n.15533, 18.01.23, DOM 19.01.2023, p.01, regulamentação, art. 132. Lei n.11364, 26.05.23, DOM 26.05.2023, p.01, legislação correlata, art. 42, § 1º.",
      "Decreto n.15643, 01.06.23, DOM 02.06.2023, p.01, legislação correlata.",
      "Lei Complementar n.0358, 19.06.23, DOM 19.06.2023, p.01, alteração, art. 5º; art. 13; art. 18; art. 20; art. 25; art. 30, § 1º; art. 32; art. 33 caput; art. 42-A acrescido; art. 46, inciso II; art. 53, inciso III, § 5º; art. 79.",
      "Lei Complementar n.385, 26.12.23, DOM 26.12.2023, p.10, alteração, art. 6º, renumerado parágrafo único para numeração § 1º e acrescido § 2º; art. 30 acrescido § 3º; art. 46, inciso I; art. 47, inciso VII.",
      "Lei Complementar n.386, 26.12.23, DOM 26.12.2023, p.10, alteração, caput art. 83; art.86, inciso I a III; art.84 (revogação).",
      "Lei Complementar n.388, 28.12.23, DOM 28.12.2023, p.03, legislação correlata, art.42, § 1º.",
    ],
  },
  {
    id: "law15",
    title: "Lei Complementar nº 320, de 27 de dezembro de 2021",
    syllabus:
      "Institui as Câmaras de Prevenção e Resolução de Conflitos da Administração Pública municipal, na estrutura administrativa e organizacional da Procuradoria-Geral do Município de Fortaleza, e dá outras providências.",
    amendments: [
      "Lei Complementar n.334, 30.09.22, DOM 30.09.2022, p.03, Supl., legislação correlata.",
      "Decreto n.15528, 10.01.23, DOM 10.01.2023, p.06, legislação correlata, art. 19,§§ 1º e 2º.",
      "Decreto n.15538, 24.01.23, DOM 24.01.2023, p.12, legislação correlata, art. 12.",
      "Decreto n.15636, 16.05.23, DOM 18.05.2023, p.02, regulamentação.",
      "Lei n.11364, 26.05.23, DOM 26.05.2023, p.01, legislação correlata.",
      "Decreto n.15643, 01.06.23, DOM 02.06.2023, p.01, legislação correlata.",
      "Lei Complementar n.0358, 19.06.23, DOM 19.06.2023, p.01, alteração, art. 5º; art. 7º, § 3º.",
      "Lei Complementar n.388, 28.12.23, DOM 28.12.2023, p.03, legislação correlata.",
    ],
  },
  {
    id: "law16",
    title: "Lei Complementar nº 358, de 19 de junho de 2023",
    syllabus:
      "Modifica as Leis Complementares n.º 311, de 16 de dezembro de 2021, n.º 315, de 23 de dezembro de 2021, e n.º 320, de 27 de dezembro de 2021, e dá outras providências.",
    amendments: [
      "Decreto n.13149, 29.04.2013, DOM 30.04.2013, p.06, legislação correlata",
    ],
  },
  {
    id: "law17",
    title: "Lei Complementar nº 385, de 26 de dezembro de 2023",
    syllabus:
      "Modifica as Leis Complementares n.º 315, de 23 de dezembro de 2021, e n.º 311, de 16 de dezembro de 2021, e dá outras providências.",
    amendments: [
      "Decreto n.13149, 29.04.2013, DOM 30.04.2013, p.06, legislação correlata",
    ],
  },
  {
    id: "law18",
    title: "Lei Complementar nº 386, de 26 de dezembro de 2023",
    syllabus:
      "Altera a composição da remuneração do cargo de Procurador do Município, na forma que indica, e dá outras providências.",
    amendments: [
      "Decreto n.13149, 29.04.2013, DOM 30.04.2013, p.06, legislação correlata",
    ],
  },
];
